import React from "react";
import { AdminModal } from "@/components/pageSettings/AdminModal";
import { ThankYouTestPanel } from "./ThankYouTestPanel";

export function BuyerTestDialog({ pageId, firm, onClose }) {
  return (
    <AdminModal eyebrow="Thank-you pages" title={`${firm} — design test`} onClose={onClose} testId="buyer-ty-test-modal" wide>
      <ThankYouTestPanel base={`/thankyou-tests/page/${pageId}`} buyer p={`ty-test-${pageId}`} />
    </AdminModal>
  );
}
